import { render, staticRenderFns } from "./ConnectWithGoogle.vue?vue&type=template&id=0a40f966&scoped=true"
import script from "./ConnectWithGoogle.vue?vue&type=script&lang=js"
export * from "./ConnectWithGoogle.vue?vue&type=script&lang=js"
import style0 from "./ConnectWithGoogle.vue?vue&type=style&index=0&id=0a40f966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40f966",
  null
  
)

export default component.exports